import { Tooltip, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { useTranslation } from 'react-i18next'

const SiteName = ({ sites }) => {
  const { t } = useTranslation()

  if (sites.length < 2) {
    return (
      <Typography variant="caption">
        {sites.map(({ name }) => {
          return name
        })}
      </Typography>
    )
  }
  return (
    <Stack direction={'row'} gap={0.5} alignItems={'center'}>
      <Tooltip
        title={
          sites.length > 10
            ? t('auth.tables.tooltip_sites')
            : sites.map(({ name }) => <li>{name}</li>)
        }
        arrow
        placement="top"
      >
        <Box padding={'4px 6px'} borderRadius={'4px'} bgcolor={'#F6F7F8'}>
          <i className="fa-regular fa-list-ul " />
        </Box>
      </Tooltip>
      <Typography variant="caption">{sites.length}</Typography>
      <Typography variant="caption">Sites</Typography>
    </Stack>
  )
}

const COLUMNS_CONFIG = [
  {
    name: 'name',
    header: {
      label: (ctx) => ctx.t('supervision.tables.label_col_count'),
    },
    value: (selection) => selection.ssid_name,
    sortBy: 'ssid_name',
    sortable: true,
  },
  {
    name: 'site_name',
    header: {
      label: (ctx) => ctx.t('supervision.tables.locations_col'),
    },
    value: (selection) => <SiteName sites={selection.sites} />,
  },
  {
    name: 'connected_stations',
    header: {
      label: (ctx) => ctx.t('supervision.tables.accesspoint_col'),
    },
    value: (selection) => `${selection.total_reachable_equipments}/${selection.total_equipments}`,
  },
]

export default COLUMNS_CONFIG
